module.exports = __webpack_public_path__ + "static/media/B9.93a8d5f1.jpg";